import StandardJourneyPrintStudio from './StandardJourneyPrintStudio';

export default function LargeTextJourneyPrintStudio(props) {
  return <StandardJourneyPrintStudio {...props} largeText />;
}
